// extracted by mini-css-extract-plugin
module.exports = {"versionNumberContainer":"version-number_versionNumberContainer__wK_B1","title":"version-number_title__g62Xh"};